module.exports = "&copy; {{copyright | date:'yyyy'}} HockeyTech Inc."